<script setup>
  import { ref, defineEmits, defineProps, onBeforeUnmount, onMounted, computed } from "vue";
  import { bus } from "./bus";

  const props = defineProps({
    sorts: {
      type: Object,
      required: false,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonType: {
      type: String,
      required: true,
      validator: (value) => ['sort', 'clear'].includes(value),
    }
  });

  const emit = defineEmits(['update:sortOrder']);
  const isSelected = ref(false);

  const isSortButton = computed(() => props.buttonType === 'sort');

  const isClearButton = computed(() => props.buttonType === 'clear');

  const handleClick = () => {
    if (isSortButton.value) {
      isSelected.value = !isSelected.value;

      if (isSelected.value) {
        emit('update:sortOrder', props.sorts.value);
      } else {
        emit('update:sortOrder', null);
      }
    } else if (isClearButton.value) {
      bus.emit('filters:reset');
    }
  };

  function localResetSearch() {
    if (isSortButton.value) {
      isSelected.value = false;
      emit("update:sortOrder", null);
    }
  }

  if (isSortButton.value) {
    onBeforeUnmount(() => bus.off('filters:reset', localResetSearch));
    onMounted(() => { bus.on('filters:reset', localResetSearch)});
  }

</script>

<template>
  <div class="container-generic-button">
    <button
      class="generic-button"
      :class="{ 'selected': isSelected && isSortButton }"
      @click="handleClick">
        <span class="cross-icon" v-if="isSelected && isSortButton">
           <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                viewBox="0 0 12 12" fill="none">
             <path d="M11 1L1 11" stroke="white" stroke-miterlimit="10" />
             <path d="M1 1L11 11" stroke="white" stroke-miterlimit="10" />
          </svg>
        </span>
      {{ buttonText }}
    </button>
  </div>
</template>

<style scoped>

</style>
